import React, { useState } from "react";
import { Download, Loader2, Volume2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import CallRecordingPlayerModal from "@/components/modals/CallRecordingPlayerModal";
import { downloadRecordingFromUrl, isRecordingNotFoundMessage } from "@/utils/recordingDownload";
import { parsePublicSesCdrId } from "@/utils/publicRecordingUrl";
import { recordingFilenameFromUrl } from "@/utils/tlRecordingReportHelpers";

/** Rapor satırından oynatıcı üst bilgisi (CDR alanları yoksa) */
export function buildReportRecordingInfo({
  title,
  url,
  reportRowId = null,
  agentName = "",
  sourceLabel = "",
  recordingRef = "",
}) {
  const ref = recordingRef || (url ? String(url).split("/").pop()?.split("?")[0] : "");
  const cdrFromUrl = url ? parsePublicSesCdrId(url) : null;
  return {
    title: title || "Ses kaydı",
    agent_name: agentName || undefined,
    report_row_id: reportRowId ?? undefined,
    cdr_id: cdrFromUrl ?? undefined,
    recording_ref: ref || undefined,
    source_label: sourceLabel || undefined,
    download_filename: url ? recordingFilenameFromUrl(url) : undefined,
  };
}

export const TlRecordingAudioModal = ({
  open,
  onClose,
  url,
  title,
  isDark,
  apiBase,
  recordInfo,
}) => (
  <CallRecordingPlayerModal
    isOpen={open}
    onClose={onClose}
    audioUrl={url}
    apiBase={apiBase}
    isDark={isDark}
    recordInfo={recordInfo || buildReportRecordingInfo({ title, url })}
  />
);

export const TlRecordingUrlActions = ({
  url, apiBase, isDark, labelClass, onPlay, compact = true,
}) => {
  const [downloading, setDownloading] = useState(false);
  const recordingUrl = String(url || "").trim();
  if (!recordingUrl) return <span className={labelClass}>—</span>;

  const handleDownload = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (downloading) return;
    setDownloading(true);
    try {
      await downloadRecordingFromUrl({
        apiBase,
        recordingUrl,
        filename: recordingFilenameFromUrl(recordingUrl),
      });
      toast.success("Ses kaydı indirildi");
    } catch (err) {
      const msg = err.message || "Ses kaydı indirilemedi";
      if (isRecordingNotFoundMessage(msg)) toast.warning(msg);
      else toast.error(msg);
    } finally {
      setDownloading(false);
    }
  };

  const btnClass = compact ? "h-7 w-7 p-0" : `h-8 px-2 ${isDark ? "border-slate-700" : ""}`;

  return (
    <div className="inline-flex items-center gap-0.5" onClick={(e) => e.stopPropagation()}>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className={`${btnClass} ${isDark ? "text-cyan-400 hover:text-cyan-300" : "text-blue-600 hover:text-blue-700"}`}
        title="Dinle"
        onClick={() => onPlay(recordingUrl)}
      >
        <Volume2 className="w-3.5 h-3.5" />
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className={`${btnClass} ${isDark ? "text-amber-400 hover:text-amber-300" : "text-amber-600 hover:text-amber-700"}`}
        title="İndir"
        disabled={downloading}
        onClick={handleDownload}
      >
        {downloading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Download className="w-3.5 h-3.5" />}
      </Button>
    </div>
  );
};
